<svg:rect
  [attr.width]="width"
  [attr.height]="height"
  [attr.rx]="em"
  [attr.fill]="node.color"
  [attr.stroke]="node.borderColor"
  [attr.data-testid]="'execute-api-node-rect'"
></svg:rect>

<svg:text
  class="mi"
  [attr.x]="0.5 * em"
  [attr.y]="0.5 * em"
  [style.font-size.px]="em"
  alignment-baseline="text-before-edge"
  text-anchor="start"
  [attr.fill]="node.frontColor"
  [attr.data-testid]="'execute-api-node-icon'"
>
  {{ node.icon }}
</svg:text>

<svg:text
  class="name"
  [attr.x]="2 * em"
  [attr.y]="0.25 * em"
  [style.font-size.px]="em"
  alignment-baseline="text-before-edge"
  text-anchor="start"
  [attr.fill]="node.frontColor"
  [attr.data-testid]="'execute-api-node-name'"
>
  {{ node?.display }}
</svg:text>

<svg:g
  class="junction"
  [index]="0"
  [dx]="0"
  [dy]="1 * em"
  type="input"
  [color]="node.borderColor"
  [node]="node"
  [attr.data-testid]="'execute-api-node-input-junction'"
></svg:g>

<svg:g
  class="junction"
  [index]="1"
  [dx]="width"
  [dy]="1 * em"
  type="output"
  [color]="node.borderColor"
  [node]="node"
  [attr.data-testid]="'execute-api-node-output-junction'"
></svg:g>

<svg:g
  class="conditions"
  *ngIf="!node.isAsync"
  [attr.data-testid]="'execute-api-node-conditions'"
>
  <svg:g
    class="condition"
    [index]="2"
    [y]="1"
    text="異常"
    i18n-text="異常"
    [attr.data-testid]="'execute-api-node-error-condition'"
  ></svg:g>
</svg:g>
